import * as React from 'react';

import { DatePicker, Space } from 'antd';
import {Moment} from 'moment';
import {Field, FormikProps} from 'formik';

interface CustomDatePickerProps {
	onChange: (value: Moment | null, dateString: string) => void;
	placeholder: string;
	initValue: string;
	formikBag: FormikProps<any>;
	name: string;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({initValue, onChange, placeholder, formikBag, name}) => {
	const dateFormat = ['MM/DD/YYYY', 'MM-DD-YYYY', 'MM.DD.YYYY'];

	return (
		<Field 
			name={name}
			render={(field) => {
				return(
					<div className={formikBag.errors[name] && formikBag.touched[name] ? 'custom-date-picker error' : 'custom-date-picker' } >
						<Space direction="vertical" size={12}>
							<DatePicker
								placeholder={placeholder}
								format={dateFormat}
								onChange={onChange}
								onBlur={() => field.form.setFieldTouched(name, true)}
							/>
						</Space>
						{
							field.form.errors[name] && field.form.touched[name] ? <div className="custom-input__error"> {field.form.errors[name]}</div> : null
						}
					</div>
				);
			}}
		/>
	);
};

export default CustomDatePicker;